import { connect } from 'react-redux';
import { getSharedPortalName, getThemeColor } from '@helpCenter/state/selectors/help-center';
import type { State } from 'state';
import { MultiHcDropdown } from './multi-hc-dropdown';

const selector = (state: State) => ({
    currentHcName: getSharedPortalName(state),
    themeColor: getThemeColor(state),
});
export default connect(selector, {})(MultiHcDropdown);
